//常量的定义
// const config = {
//   baseurl:'https://172.16.114.5:8088/MGT2'
// }
//函数的定义
// function formatXml(text) {
//   return text
// }
//导出 {常量名、函数名}
// export {config,is_weixn}

import Vue from "vue";

const isLogin = false;
import axios from '../../../node_modules/axios'
import {getToken, getAccessToken,} from "../../common/api/api";

const config = {
  AppSecret: 'ee7cc693908469ba95fd465a6ebd87dd',
  coverSuffix: '-newslist7.0.4', // "-newslistnormal61", -smallimage3G
  coverBigSuffix: '', // "-newslistbig6", -bigimage4G
  AppID: "wx89cd743f8cdc3eec",
  wsStatisUrl: 'https://wscdn.ql1d.com',
}

// 判断是否微信浏览器  授权登录
function isWeixin() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
};

function login() {
  const CODE = GetQueryString("code");
  const STATE = GetQueryString("state");
  if (STATE !== null) { // 此页面为微信重定向过来且用户允许授权
    if (CODE === null) {
      clearCookie('token');
    } else {
      let params = {
        "code": CODE,
      };
      //获取access_token
      getAccessToken(params).then(res => {
        if (res.data.rc == 0) {
          let accessInfo = res.data.data;
          //获取token
          let params1 = {
            "openId": accessInfo.openid,
            "unionId": accessInfo.unionid,
            "accessToken": accessInfo.access_token
          };
          getToken(params1).then(re => {
            if (re.data.rc == 0) {
              let tokenInfo = re.data.data;
              setCookie('token', tokenInfo.tokenId, 7)
              // location.reload();
              window.location.href = window.location.href.split('&')[0];
            } else {
              toast('授权失败', 2000);
            }
          });
        } else {
          toast('授权失败', 2000);
        }
      })
    }
  }

};

function WXauthorize() {
  if (isWeixin()) {
    if (!getCookie('token')) {
      const origin_state = Math.floor(Math.random() * 1000000);
      const SCOPE = "snsapi_userinfo";
      let currentURL = window.location.href;
      window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + config.AppID + '&redirect_uri=' + encodeURI(currentURL) + '&response_type=code&scope=' + SCOPE + '&state=' + origin_state + '#wechat_redirect'
    }
  }
};



//设置cookie
function setCookie(cname, cvalue, exday) {
  var d = new Date();
  d.setTime(d.getTime() + (exday *24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
};

// cookie
function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)) {
    return unescape(arr[2]);
  } else {
    return null;
  }
  // document.cookie="cityId=" + this.cityId+ ";expires=" + exp.toGMTString();
};

//清除cookie
function clearCookie(name) {
  setCookie(name, "", -1);
};

function GetQueryString(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return r
};

function toast(msg, duration) {
  duration = isNaN(duration) ? 3000 : duration;
  var m = document.createElement('div');
  m.innerHTML = msg;
  m.style.cssText = "max-width:60%;min-width: 150px;padding:0 14px;height: 40px;color: rgb(255, 255, 255);line-height: 40px;text-align: center;border-radius: 4px;position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);z-index: 999999;background: rgba(0, 0, 0,.7);font-size: 14px;";
  document.body.appendChild(m);
  setTimeout(function () {
    var d = 0.5;
    m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
    m.style.opacity = '0';
    setTimeout(function () {
      document.body.removeChild(m)
    }, d * 1000);
  }, duration);
};
export {WXauthorize, isWeixin, login, getCookie}



// WEBPACK FOOTER //
// ./src/common/js/authorize.js